import NotFound from '../../../base/pages/errorPages/NotFound';

const notFound: NotFound = {
  title: 'Seite nicht gefunden',
  subtitle: 'Wir alle machen Fehler, jeder sollte eine zweite Chance bekommen.',
  quip: 'Vielleicht solltest du es nochmal versuchen, aber ohne die Socken.'
};

export default notFound;
